<template>
  <div class="flex flex-col h-full bg-gray-800 w-64">
    <div v-if="$isSuperAdmin" class="flex-none flex flex-col px-1">
      <div class="flex gap-1 py-1">
        <BaseButton
          v-for="(sidebar, key) in sidebars"
          :key="key"
          type="button"
          primary
          :outline="!isCurrentSidebar(key)"
          small
          class="w-full text-center"
          @click="switchSidebar(key)"
        >
          {{ key }}
        </BaseButton>
      </div>
    </div>
    <div class="flex-1 overflow-hidden">
      <Sidebar />
      <!-- <component :is="current" /> -->
    </div>
    <div v-if="$isSuperAdmin && accountSidebar !== current" class="flex-none flex flex-col p-1">
      <BaseButton type="button" success small class="w-full text-center" @click="setAccountSidebar">
        Set as account sidebar
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { accountOptionsClient } from '@/api/clients/admin';
import { ACCOUNTS } from '@/store/entities/schema_types';
import Sidebar from './Sidebar.vue';

const sidebars = {
  A: 'SidebarA',
  B: 'SidebarB',
  C: 'SidebarC',
  D: 'SidebarD',
  E: 'SidebarE',
  F: 'SidebarF',
  G: 'SidebarG',
  H: 'SidebarH',
};

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      current: null,
      sidebars: Object.freeze(sidebars),
    };
  },
  computed: {
    accountSidebar() {
      return this.$currentAccount?.options?.sidebar || null;
    },
  },
  created() {
    this.setDefaultSidebar();
  },
  methods: {
    setDefaultSidebar() {
      this.current = this.$currentAccount?.options?.sidebar || this.sidebars.A;
    },
    isCurrentSidebar(sidebar) {
      return this.current === this.sidebars[sidebar];
    },
    switchSidebar(sidebar) {
      this.current = this.sidebars[sidebar] || this.sidebars.A;
    },
    setAccountSidebar() {
      if (this.$currentAccount?.options?.sidebar === this.current) {
        return;
      }

      return accountOptionsClient
        .update(this.$currentAccount.id, {
          sidebar: this.current,
        })
        .then((response) => {
          this.$store.dispatch(
            'entities/persistEntities',
            {
              type: ACCOUNTS,
              data: response.data,
            },
            { root: true }
          );
        })
        .catch(() => {
          this.switchSidebar(this.$currentAccount?.options?.sidebar);
        });
    },
  },
};
</script>
